// Library imports
import { useEffect, useRef, useState } from "react";

/**
 * 動画の最適化中でも送信を予約でき、すべて終わったら自動で送信する
 * 最適化が失敗した・送信できない状態になった（必須の動画を外した等）ときは予約を取り消す
 * @param {{ busy: boolean, hasError: boolean, canSubmit: boolean, submit: Function }} options canSubmit は最適化中かどうか以外の送信条件
 * @returns {{ reserved: boolean, request: Function, cancel: Function }}
 */
export const useSubmitWhenReady = ({ busy, hasError, canSubmit, submit }) => {
    const [reserved, setReserved] = useState(false);
    const submitRef = useRef(submit);
    submitRef.current = submit;

    useEffect(() => {
        if (!reserved) return;
        if (hasError || !canSubmit) {
            setReserved(false);
            return;
        }
        if (!busy) {
            setReserved(false);
            submitRef.current();
        }
    }, [reserved, busy, hasError, canSubmit]);

    const request = () => {
        if (!canSubmit || hasError) return;
        if (busy) setReserved(true);
        else submit();
    };

    return { reserved, request, cancel: () => setReserved(false) };
};

/** 最適化する動画の進捗（平均）と、終わった本数 */
export const calcOptimizeProgress = (files) => {
    const targets = Object.values(files).filter((f) => f.optimize);
    if (!targets.length) return { progress: 1, done: 0, total: 0 };
    const progressOf = (f) => (f.status === 'done' ? 1 : f.progress || 0);
    return {
        progress: targets.reduce((sum, f) => sum + progressOf(f), 0) / targets.length,
        done: targets.filter((f) => f.status === 'done').length,
        total: targets.length,
    };
};
